(ns ui.components.card.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Card/styles.json
;; Source commit: c06da9953afb30bb194c3b2715965fbb16d77c7f
;; ----------------------------------------------------------------------------

(def card
  {:description
   {:base
    "tw2-font-sans tw2-text-card-description-text tw2-text-label-sm",
    :compound-variants [],
    :default-variants {}},
   :avatar-fallback
   {:base
    "tw2-h-3 tw2-w-3 tw2-shrink-0 tw2-rounded-full tw2-bg-avatar-bg-default",
    :compound-variants [],
    :default-variants {}},
   :footer-right
   {:base
    "tw2-flex tw2-shrink-0 tw2-items-center tw2-gap-2 tw2-text-card-description-text",
    :compound-variants [],
    :default-variants {}},
   :block
   {:base "tw2-w-full", :compound-variants [], :default-variants {}},
   :hit-target
   {:base
    "tw2-absolute tw2-inset-0 tw2-z-0 tw2-border-0 tw2-bg-transparent tw2-p-0 focus-visible:tw2-outline-none focus-visible:tw2-outline-2 focus-visible:tw2-outline-offset-2 focus-visible:tw2-outline-btn-primary-bg-focus",
    :compound-variants [],
    :default-variants {}},
   :meta
   {:base
    "tw2-flex tw2-shrink-0 tw2-items-center tw2-gap-0.5 tw2-text-card-description-text",
    :compound-variants [],
    :default-variants {}},
   :_meta
   {:tokens
    ["avatar-bg-default"
     "btn-primary-bg-focus"
     "card-bg-default"
     "card-bg-hover"
     "card-bg-pressed"
     "card-bg-selected"
     "card-bg-selected-hover"
     "card-border-default"
     "card-border-hover"
     "card-border-pressed"
     "card-border-selected"
     "card-border-selected-hover"
     "card-bottom-padding"
     "card-content-offset"
     "card-description-text"
     "card-icon-default"
     "card-status-bar-height"
     "card-status-bar-offset"
     "card-status-border-width"
     "card-text-attribute"
     "card-text-label-attribute"
     "card-title-text"
     "card-width"
     "kanban-attribute-label-max-width"
     "label-md-strong-font-size"
     "label-md-strong-font-weight"
     "label-md-strong-line-height"
     "label-sm-font-size"
     "label-sm-font-weight"
     "label-sm-line-height"
     "label-sm-strong-font-size"
     "label-sm-strong-font-weight"
     "label-sm-strong-line-height"
     "radius-card"
     "spacing-card-gap"
     "spacing-card-padding"
     "status-lost-bar"
     "status-on-hold-bar"
     "status-success-bar"],
    :generated-from "src/components/Card/Card.styles.ts",
    :composes
    [{:slot "menu", :component "dropdownMenu", :variant "content"}
     {:slot "dueDate", :component "tooltip", :variant "top"}
     {:slot "attributeValue", :component "tooltip", :variant "top"}
     {:slot "tasks", :component "tooltip", :variant "top"}
     {:slot "attachments", :component "tooltip", :variant "top"}
     {:slot "assignee", :component "tooltip", :variant "top"}],
    :a11y
    ["An interactive card with no inner menu is a button. With href and no inner menu, it is a link."
     "A kanban card with a menu uses a separate hit target under the content: a button, or a link when href is set. The menu is not inside that control. Enter and Space activate the card. Clicks and keys from the menu do not."
     "The menu and footer sit above the hit target and keep their own pointer events."
     "Focus uses focus-visible outline-2, outline-offset-2, and outline-btn-primary-bg-focus."
     "Selected is aria-pressed on a button. On a link it is aria-current=true. aria-selected is not used because the card is not a listbox option."
     "The status bar includes visually hidden text: \"Status: Success\", \"Status: On hold\", or \"Status: Lost\". statusLabel replaces that text."
     "The footer date, counters, and avatar do not truncate. The avatar tooltip is the owner name. A reference code is an attribute row, not footer text."]},
   :attribute-label
   {:base
    "tw2-shrink-0 tw2-max-w-kanban-attribute-label-max-width tw2-truncate tw2-font-sans tw2-text-card-text-label-attribute tw2-text-label-sm-strong",
    :compound-variants [],
    :default-variants {}},
   :raise
   {:base "tw2-pointer-events-auto tw2-relative tw2-z-10",
    :compound-variants [],
    :default-variants {}},
   :content
   {:base
    "tw2-mb-card-content-offset tw2-flex tw2-w-full tw2-flex-col tw2-items-start tw2-gap-3 tw2-px-3 tw2-pb-4",
    :status-bar {:true "", :false "tw2-pt-4"},
    :compound-variants [],
    :default-variants {:status-bar true}},
   :title-group
   {:base "tw2-min-w-0 tw2-flex-1",
    :compound-variants [],
    :default-variants {}},
   :icon
   {:base "tw2-h-3 tw2-w-3 tw2-shrink-0 tw2-text-card-icon-default",
    :compound-variants [],
    :default-variants {}},
   :content-shield
   {:base "tw2-relative tw2-z-10 tw2-w-full tw2-pointer-events-none",
    :compound-variants [],
    :default-variants {}},
   :footer
   {:base "tw2-flex tw2-w-full tw2-items-center tw2-justify-between",
    :compound-variants [],
    :default-variants {}},
   :attribute-list
   {:base "tw2-flex tw2-w-full tw2-flex-col tw2-gap-1",
    :compound-variants [],
    :default-variants {}},
   :header
   {:base
    "tw2-flex tw2-w-full tw2-items-start tw2-justify-between tw2-gap-2",
    :compound-variants [],
    :default-variants {}},
   :title
   {:base
    "tw2-font-sans tw2-text-label-md-strong tw2-text-card-title-text",
    :truncate {:true "tw2-w-full tw2-min-w-0 tw2-truncate", :false ""},
    :compound-variants [],
    :default-variants {:truncate false}},
   :status-bar
   {:base
    "tw2-h-card-status-bar-height tw2-w-full tw2-mb-card-status-bar-offset tw2-rounded-card tw2-border-t-card-status-border-width",
    :status
    {:won "tw2-border-status-success-bar",
     :on-track "tw2-border-status-on-hold-bar",
     :lost "tw2-border-status-lost-bar"},
    :compound-variants [],
    :default-variants {}},
   :attribute-value
   {:base
    "tw2-min-w-0 tw2-truncate tw2-text-right tw2-font-sans tw2-text-card-text-attribute tw2-text-label-sm-strong",
    :compound-variants [],
    :default-variants {}},
   :avatar
   {:base
    "tw2-h-3 tw2-w-3 tw2-shrink-0 tw2-rounded-full tw2-object-cover",
    :compound-variants [],
    :default-variants {}},
   :count
   {:base "tw2-flex tw2-shrink-0 tw2-items-center tw2-gap-0.5",
    :compound-variants [],
    :default-variants {}},
   :status-label
   {:base "tw2-sr-only", :compound-variants [], :default-variants {}},
   :meta-text
   {:base "tw2-font-sans tw2-text-label-sm",
    :truncate {:true "tw2-min-w-0 tw2-truncate", :false ""},
    :compound-variants [],
    :default-variants {:truncate false}},
   :shell
   {:base
    "tw2-flex tw2-w-card tw2-flex-col tw2-items-start tw2-rounded-card tw2-border tw2-transition-all tw2-duration-150 tw2-ease-in-out",
    :variant
    {:settings
     "tw2-gap-card-gap tw2-border-card-border-default tw2-bg-card-bg-default tw2-shadow-2xs tw2-p-card-padding",
     :kanban ""},
    :interactive
    {:true
     "tw2-cursor-pointer tw2-text-left focus-visible:tw2-outline-none focus-visible:tw2-outline-2 focus-visible:tw2-outline-offset-2 focus-visible:tw2-outline-btn-primary-bg-focus",
     :false ""},
    :selected {:true "", :false ""},
    :compound-variants
    [{:variant "settings",
      :interactive true,
      :class-name
      "hover:tw2-border-card-border-hover hover:tw2-bg-card-bg-hover hover:tw2-shadow-sm active:tw2-border-card-border-pressed active:tw2-bg-card-bg-pressed active:tw2-shadow-none"}
     {:variant "kanban",
      :interactive true,
      :selected false,
      :class-name
      "tw2-border-card-border-default tw2-bg-card-bg-default hover:tw2-border-card-border-hover hover:tw2-bg-card-bg-hover hover:tw2-shadow-sm active:tw2-border-card-border-pressed active:tw2-bg-card-bg-pressed active:tw2-shadow-none"}
     {:variant "kanban",
      :selected true,
      :class-name
      "tw2-border-card-border-selected tw2-bg-card-bg-selected hover:tw2-border-card-border-selected-hover hover:tw2-bg-card-bg-selected-hover"}],
    :default-variants
    {:variant "settings", :interactive false, :selected false}},
   :kanban-layout
   {:base
    "tw2-gap-0 tw2-p-0 tw2-pb-card-bottom-padding tw2-shadow-xs tw2-relative",
    :compound-variants [],
    :default-variants {}},
   :attribute-row
   {:base
    "tw2-flex tw2-w-full tw2-items-baseline tw2-justify-between tw2-gap-2",
    :compound-variants [],
    :default-variants {}}})
